// App
export const APP_SET_TOKEN = 'app/APP_SET_TOKEN';
export const APP_REMOVE_TOKEN = 'app/APP_REMOVE_TOKEN';
export const APP_SET_CURRENT_LANGUAGE = 'app/SET_CURRENT_LANGUAGE';
export const APP_TOGGLE_PROCESSING = 'app/TOGGLE_PROCESSING';
export const APP_SET_STOMP_CONFIG = 'app/SET_STOMP_CONFIG';
export const APP_SET_GAME_STATE = 'app/APP_SET_GAME_STATE';
export const APP_RESET_GAME_STATE = 'app/APP_RESET_GAME_STATE';
export const APP_CLOSE_PREDICTIONS = 'app/APP_CLOSE_PREDICTIONS';
export const APP_START_PREDICTIONS = 'app/APP_START_PREDICTIONS';
export const APP_POST_RESULTS = 'app/APP_POST_RESULTS';
export const APP_NEXT_COMPETITION = 'app/APP_NEXT_COMPETITION';
export const APP_CANCEL_RESULTS = 'app/APP_CANCEL_RESULTS';
export const APP_END_HALF_INNING = 'app/APP_END_HALF_INNING';
export const APP_SET_PREDICTIONS_TYPES = 'app/APP_SET_PREDICTIONS_TYPES';
export const APP_SET_GAMES = 'app/APP_SET_GAMES';
export const APP_SET_STOMP_STATE = 'app/APP_SET_STOMP_STATE';
export const APP_SET_STOMP_SUBSCRIPTION = 'app/APP_SET_STOMP_SUBSCRIPTION';
export const APP_RESET_STOMP_SUBSCRIPTION = 'app/APP_RESET_STOMP_SUBSCRIPTION';
export const APP_UPDATE_GAME = 'app/APP_UPDATE_GAME';
export const APP_SET_DUEL_PAGE_DATA = 'app/APP_SET_DUEL_PAGE_DATA';
export const APP_STOMP_DEACTIVATE = 'app/APP_STOMP_DEACTIVATE';
export const APP_SET_CONNECTION_STATUS = 'app/APP_SET_CONNECTION_STATUS';
export const APP_SET_OFFLINE_MODAL_INSTANCE =
  'app/APP_SET_OFFLINE_MODAL_INSTANCE';

// User
export const USER_SET_DATA = 'user/USER_SET_DATA';
export const USER_REMOVE_DATA = 'user/USER_REMOVE_DATA';
